import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsSankey from 'highcharts/modules/sankey';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { journeyToFirstZone } from 'api/sentinelAPI';

HighchartsSankey(Highcharts);

const legends = [
  {
    zone: 'Entrance',
    color: '#00ac69'
  },
  {
    zone: 'Mobile',
    color: '#60696d'
  },
  {
    zone: 'Laptop',
    color: '#9111fa'
  },
  {
    zone: 'Accessories',
    color: '#00cfd5'
  },
  {
    zone: 'Playstation',
    color: '#fa7211'
  },
  {
    zone: 'Help Desk',
    color: '#1f61cc'
  },
  {
    zone: 'Still in store',
    color: '#86efac'
  }
];

const initialOptions = {
  title: {
    text: ''
  },
  accessibility: {
    point: {
      valueDescriptionFormat: '{index}. {point.from} to {point.to}, {point.weight}.'
    }
  },
  tooltip: {
    headerFormat: null,
    pointFormat: '{point.fromNode.name} \u2192 {point.toNode.name}: {point.weight:.2f} Customers',
    nodeFormat: '{point.name}: {point.sum:.2f} Customers'
  },
  series: [
    {
      keys: ['from', 'to', 'weight'],
      nodes: [
        { id: 'Entrance', color: '#00ac69' },
        { id: 'help_desk', color: '#1f61cc' },
        { id: 'accessories', color: '#00cfd5' },
        { id: 'mobile', color: '#60696d' },
        { id: 'playstation', color: '#fa7211' },
        { id: 'laptop', color: '#9111fa' }
      ],
      data: [],
      type: 'sankey',
      name: 'Sankey demo series',
      dataLabels: {
        enabled: false
      }
    }
  ],
  legend: {
    enabled: true
  }
};

const Sankey = () => {
  const date = useSelector((state) => state.customization.currentDate);
  const [options, setOptions] = useState(initialOptions);
  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  useEffect(() => {
    const commonBody = {
      start_time: formattedStartTimeIST,
      end_time: formattedEndTimeIST,
      start_date: date
    };
    const fetchData = async () => {
      try {
        const data = await journeyToFirstZone(commonBody);
        const formattedData = data.map((d) => [d?.from, d?.to, d?.count]);
        setOptions((prevOptions) => ({
          ...prevOptions,
          series: [
            {
              ...prevOptions.series[0],
              data: formattedData
            }
          ]
        }));
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [date, formattedStartTimeIST, formattedEndTimeIST]);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', margin: '0 15%' }}>
        {legends.map((leg, ind) => (
          <div className="flex justify-center align-middle" key={ind}>
            <div
              style={{ height: '10px', width: '10px', borderRadius: '50%', backgroundColor: `${leg.color}`, margin: '5px 10px 0 ' }}
            ></div>
            <div>{leg.zone}</div>
          </div>
        ))}
      </div>
      <Box sx={{ position: 'relative' }}>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <div style={{ background: 'white', width: '80px', height: '15px', position: 'absolute', right: '0', bottom: '0' }}></div>
      </Box>
    </>
  );
};

export default Sankey;
